import { configureStore, ThunkAction, Action, combineReducers } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import CountReducer from "../components/CountSlice";
import NavReducer from "../components/Nav/NavSlice";
//const mimicUid = useReduxSelector(s=>s.revI.mimicUid)import AuthReducer from "../slices/AuthSlice";
import TicketReducer from "../slices/TicketSlice";
import TicketDetailReducer from "../slices/TicketDetailSlice";
import TicketDetailUIReducer from "../slices/TicketDetailUISlice";
import ActionReducer from "../slices/ActionSlice";
import SelectedActionReducer from "../slices/SelectedActionsSlice";
import FeedReducer from "../slices/FeedSlice";
import FavoriteReducer from "../slices/FavoriteSlice";
import RightBarReducer from "../slices/RightBarSlice";
import EmailActionReducer from "../slices/EmailActionSlice";
import FilterReducer from "../slices/FilterSlice";
import FileReducer from "../slices/FileSlice";
import KBReducer from "../slices/KBSlice";
import RevelationIframeReducer from "../slices/RevelationSlice";
import { Api } from "./api/BaseApi";
import { reducer as oidcReducer } from 'redux-oidc';
import { rtkQueryErrorLogger } from "./api/errorHandling/ApiErrorHandler";
import { createDynamicMiddlewares } from 'redux-dynamic-middlewares'
import EventReducer from "../slices/EventSlice";

const dynamicMiddlewaresInstance = createDynamicMiddlewares()

const staticReducers = {
  kb: KBReducer,
  files: FileReducer,
  ticketDetails: TicketDetailReducer,
  ticketDetailsUI: TicketDetailUIReducer,
  newTicket: TicketReducer,
  actionDetails: ActionReducer,
  selectedActionsStore: SelectedActionReducer,
  auth: oidcReducer,
  filter: FilterReducer,
  rightBar: RightBarReducer,
  nav: NavReducer,
  count: CountReducer,
  feed: FeedReducer,
  favs: FavoriteReducer,
  emailAction: EmailActionReducer,
  eventDetails: EventReducer,
  revI: RevelationIframeReducer,
  [Api.reducerPath]: Api.reducer
};


// Configure the store
//const store = function createStore(initialState) {
export const store = configureStore({
  reducer: staticReducers,
  devTools: true,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: false //Stop OIDC serializable warnings
    }).concat(Api.middleware)
      .concat(rtkQueryErrorLogger).concat(dynamicMiddlewaresInstance.enhancer)


  },
});

// Add a dictionary to keep track of the registered async reducers
//const asyncReducers = {}
// Create an inject reducer function
// This function adds the async reducer, and creates a new combined reducer
// const injectReducer = (key, asyncReducer) => {
//   asyncReducers[key] = asyncReducer
//   store.replaceReducer(createReducer(asyncReducers))
// }
// function registerReducers(newReducer: Reducer) {
//   store.replaceReducer(
//     combineReducers({ ...staticReducers, ...{ chatApi: newReducer } })
//   );
// }

//import chat API reducer
// import("chat/ChatApi").then(({ ChatApi }) => {
//   console.log('store.replaceReducer', ChatApi, ChatApi.reducer);
//   registerReducers(ChatApi.reducer)
//   dynamicMiddlewaresInstance.addMiddleware(ChatApi.middleware)
// }
// );

//import chat reducers, api, and middleware for Signal R
//@ts-expect-error
import("chat/ChatReducers").then(({ ChatApi, ChatSlice, SignalRMiddleware, ticketViewMiddleware, ticketViewSlice }) => {
  //console.warn('store.replaceReducer ChatApi ChatSlice', ChatApi, SignalRMiddleware, 'ticketViewMiddleware=', ticketViewMiddleware);

  console.warn('store replaceReducer', ticketViewSlice.name, ticketViewSlice.reducer)

  store.replaceReducer(
    combineReducers({ ...staticReducers, ...{ [ChatApi.reducerPath]: ChatApi.reducer, [ChatSlice.name]: ChatSlice.reducer, [ticketViewSlice.name]: ticketViewSlice.reducer } })
  );
  dynamicMiddlewaresInstance.addMiddleware(ChatApi.middleware)
  dynamicMiddlewaresInstance.addMiddleware(SignalRMiddleware)
  dynamicMiddlewaresInstance.addMiddleware(ticketViewMiddleware)

}
);




// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
setupListeners(store.dispatch);


export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
